module.exports = __webpack_public_path__ + "img/Element7_Fehler_Ziffernrechnen.d6c37a78.png";